import { Avatar } from '@calendly/ui/components/avatar'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy'
import { BodyText } from '@calendly/ui/components/typography'

import { getLocationKindLabel } from '../utils'

export const ReadonlyHosts = ({ membership }) => {
  const locationKind = membership.locationConfiguration?.kind
  const locationKindText = getLocationKindLabel(locationKind)

  if (!membership.enabled) return null

  return (
    <FlexLayout gap={16}>
      <FullStoryExclude>
        <Avatar size="small" src={membership.avatar_url} letter={membership.avatar_letter} alt={membership.name} />
      </FullStoryExclude>
      <div>
        <BodyText>
          <FullStoryMask>
            {membership.name}
          </FullStoryMask>
        </BodyText>
        <BodyText size="x-small" color="muted">{locationKindText}</BodyText>
      </div>
    </FlexLayout>
  )
}
